import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConsumableLabelProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/consumable-label';

  public getConsumableLabel(itemCode: string, locationCode?: string): Observable<Blob> {
    let url = `${this.baseUrl}/${encodeURIComponent(itemCode)}`;
    if (locationCode) {
      url += `?locationCode=${encodeURIComponent(locationCode)}`;
    }
    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
